import { Footer, Modal } from 'tio-ui/components/modal';
import { t } from 'ember-intl';
import { PhWarning } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

export interface MarkPaidConfirmationModalSignature {
  Element: HTMLElement;
  Args: {
    isOpen: boolean;
    isReceivingContributions?: boolean;
    onClose: () => void;
    onSubmit: () => void | Promise<void>;
  };
}

const MarkPaidConfirmationModal: TOC<MarkPaidConfirmationModalSignature> = <template>
  <Modal @isOpen={{@isOpen}} @onClose={{@onClose}} @backdrop="faded" @size="lg" as |m|>
    <m.Header>
      <PhWarning @size="24" class="text-yellow-500 inline" />
      {{t "common.accounts.mark_paid"}}
    </m.Header>
    <m.Body>
      <p class="font-semibold mb-4">{{t "common.accounts.mark_paid_modal_body" htmlSafe=true}}</p>
      {{#if @isReceivingContributions}}
        <p class="text-gray-500">
          {{t "common.accounts.mark_paid_contributions_disclaimer"}}
        </p>
      {{/if}}
    </m.Body>
    <m.Footer>
      <Footer
        @onCancel={{@onClose}}
        @onSubmit={{@onSubmit}}
        @submitText={{t "common.accounts.mark_paid"}}
        @submitIntent="danger"
      />
    </m.Footer>
  </Modal>
</template>;

export default MarkPaidConfirmationModal;
